module.exports = __webpack_public_path__ + "img/main-like.958af971.svg";